var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtoile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10.593,
    viewBox: "0 0 11 10.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9662",
    "data-name": "Trac\\xE9 9662",
    d: "M34.444,43.193l-2.831-2.081a.316.316,0,0,0-.375,0l-2.831,2.081a.316.316,0,0,1-.488-.352l1.09-3.37a.316.316,0,0,0-.114-.353l-2.839-2.075a.316.316,0,0,1,.187-.572h3.5a.316.316,0,0,0,.3-.22l1.081-3.37a.316.316,0,0,1,.6,0l1.081,3.37a.316.316,0,0,0,.3.22h3.5a.316.316,0,0,1,.187.572l-2.839,2.075a.316.316,0,0,0-.114.353l1.09,3.37A.316.316,0,0,1,34.444,43.193Z",
    transform: "translate(-25.925 -32.663)",
    fill: "#f6c344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoile);
export default __webpack_public_path__ + "static/media/Etoile.564396b300eb1fdbe849d180d009482a.svg";
export { ForwardRef as ReactComponent };